import styled from 'styled-components';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';

export const RatesListFooter = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	border-top: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
`;

export const FXRatesFormFooterItem = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
`;

export const FXRatesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
	margin-top: 1rem;

	.mantine-Button-root {
		width: 100%;
	}
`;

export const DrawerContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
`;

export const RatesListFooterItemText = styled(TextV2)`
	color: ${({ theme }) => theme.v2.color.neutral[600]};
`;

export const RatesListFooterLink = styled.a`
	color: ${({ theme }) => theme.v2.color.neutral[600]};
	text-decoration: underline;

	&:hover {
		color: ${({ theme }) => theme.v2.color.neutral[800]};
	}
`;

export const StatusDot = styled.div<{ $status: 'live' | 'valuation' | 'modified' }>`
	height: 0.5rem;
	width: 0.5rem;
	min-height: 0.5rem;
	min-width: 0.5rem;
	border-radius: 100%;
	background-color: ${({ theme, $status }) => {
		switch ($status) {
			case 'live':
				return theme.v2.color.teal[800];
			case 'valuation':
				return theme.v3.colors.blue[6];
			case 'modified':
				return theme.v2.color.neutral[700];
		}
	}};
`;
